import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { Country } from "../../../model/country";
import { DocType } from "../../../model/doc-type";
import { CustomValidator } from "src/shared/custom-validator";
import { Account } from "../../../model/form/account";
import { AuthService } from "src/app/service/auth.service";
import { Title } from "@angular/platform-browser";
import { cpf, cnpj } from "cpf-cnpj-validator";
import { Message, MessageService } from "primeng/api";
import { CognitoException } from "src/app/model/enum/cognito-exception";
import { COUNTRY_LIST } from "src/app/model/mockup/country-mockup";
import { enviroment } from "src/environments/environment";
import { CountryService } from "src/app/service/country.service";
import { GeolocationService } from "src/app/service/geolocation.service";
import { PhoneCountry } from "src/app/model/country";
import { Language } from "src/app/model/language";
import { LANGUAGE_LIST } from "src/app/model/mockup/language-mockup";
import { LanguageEnum } from "src/app/model/enum/language-enum";

@Component({
  selector: "app-create-account",
  templateUrl: "./create-account.component.html",
  styleUrl: "./create-account.component.css",
})
export class CreateAccountComponent implements OnInit, OnDestroy {
  public form!: FormGroup;

  countryOptions: Country[] = [];
  countries: Country[] = [];
  docType: DocType | null = null;
  loginUrl: string;
  activateAccountUrl: string;
  isBrasil: boolean = false;
  showBirthDate: boolean = true;
  placeHolderName: string = "";
  maxDate: Date | undefined;
  submitBtnLoading: boolean = false;
  messagesDocNumber: Message[] = [];
  messagesEmail: Message[] = [];
  messagesPassword: Message[] = [];
  messagesCookies: Message[] = [];
  messagesName: Message[] = [];
  messages: Message[] = [];
  passwordsMatch: boolean = false;
  private destroy$ = new Subject<void>();
  backBtnLoading: boolean = false;
  accountInitiate!: Account;
  currentMask: string = "(99) 99999 9999";
  selectedCountry: any;
  selectGeoCountry: any = null;
  languageCode: string | null;

  languageOptions: Language[];
  DEFAULT_LANGUAGE: Language;
  lastLanguage: Language;
  language: Language;
  userInteractedLanguage = false;
  initialLanguageResolved = false;
  privacypolicypdf: string = "";
  termsofusepdf: string = "";
footerBackground: string = "url('assets/img/dashboard/Header.svg')";
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private translocoService: TranslocoService,
    private authService: AuthService,
    private countryService: CountryService,
    private messageService: MessageService,
    private geolocationService: GeolocationService
  ) {
    this.loginUrl = "/login";
    this.activateAccountUrl = "/activate-account";
    this.languageOptions = LANGUAGE_LIST as [];
    // Fallback robusto: procura EN_US pelo name em vez de índice fixo
    this.DEFAULT_LANGUAGE = this.languageOptions.find(l => l.name === LanguageEnum.EN_US) || this.languageOptions[0];
    this.language = this.DEFAULT_LANGUAGE;
    this.lastLanguage = this.DEFAULT_LANGUAGE;
    this.languageCode = null;
  }
  

  async ngOnInit() {
    // Lógica unificada: usa sessionStorage se válido; se inválido tenta geolocalização
    this.languageCode = this.normalizeLanguage(sessionStorage.getItem('language'));
    if (this.languageCode !== LanguageEnum.PT_BR && this.languageCode !== LanguageEnum.EN_US && this.languageCode !== LanguageEnum.ES_ES) {
      // inválido -> geolocalização depois ajusta
      this.getLocation();
    } else {
      // válido -> aplica
      sessionStorage.setItem('language', this.languageCode);
      this.language = this.getLanguage(this.languageCode);
      this.changeLanguage(this.language.name);
      this.refreshLanguageOptions();
    }
    this.initialLanguageResolved = true;

    // Login social (Google/Apple) sem conta ainda: vem com email/name já
    // validados pelo provedor — só falta completar o cadastro normal.
    const socialEmail = this.route.snapshot.queryParamMap.get('email');
    const socialName = this.route.snapshot.queryParamMap.get('name');
    const initialAccount = new Account();
    if (socialEmail) initialAccount.email = socialEmail;
    if (socialName) initialAccount.name = socialName;
    this.createForm(initialAccount);
    this.refreshLanguageOptions();

    if (socialEmail) {
      this.translocoService.selectTranslate('user.createAccount.socialSignupContinue')
        .pipe(take(1))
        .subscribe((value) => this.showMessage('info', value));
    }

    this.accountInitiate = new Account();
    if (enviroment.MOCKUP) {
      this.countryOptions = COUNTRY_LIST;
      this.adaptForm();
    } else {
      this.getAllCountry();
    }

    // Não normaliza email em tempo real: chamar setValue() durante a digitação
    // reseta o cursor pro fim do input. A normalização lowercase agora roda no
    // blur (checkEmail) e novamente em onSubmit antes de enviar pra API.
    this.form.controls['docNumber'].valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.applyDocMaskAndValidate(value);
      });
    this.privacypolicypdf =
      this.languageCode === "pt-br"
        ? "assets/docs/politicas-de-privacidade-do-ftcloud-pt-v01.pdf"
        : "assets/docs/politicas-de-privacidade-do-ftcloud-en-v01.pdf";
    this.termsofusepdf =
      this.languageCode === "pt-br"
        ? "assets/docs/termos-de-uso-do-ftcloud-pt-v01.pdf"
        : "assets/docs/termos-de-uso-do-ftcloud-en-v01.pdf";
  }

  getAllCountry() {
    this.countryService.getAllCountry().subscribe({
      next: (countries) => {
        this.countryOptions = CountryService.toCountryList(countries);
        this.countries = CountryService.toCountryList(countries);
        // Só tenta geolocalização se a linguagem inicial era inválida
          this.getLocation();

      },
      error: (_) => {
        (this.countryOptions = []), (this.countries = []);
      },
    });
  }

  /**
   * Recarrega a lista de países no idioma ATUAL (a tradução dos nomes vem do backend via
   * `?Language=`) e re-mapeia a seleção corrente para o objeto equivalente da nova lista (por id),
   * preservando o país escolhido pelo usuário. Diferente de `getAllCountry()`, NÃO chama
   * `getLocation()` — que re-selecionaria o país por geolocalização e apagaria a escolha do usuário.
   */
  private reloadCountriesForLanguage(): void {
    if (enviroment.MOCKUP) return;
    this.countryService.getAllCountry().subscribe({
      next: (countries) => {
        const list = CountryService.toCountryList(countries);
        this.countryOptions = list;
        this.countries = list;
        this.remapSelectedCountry("country", list);
        this.remapSelectedCountry("phoneCountry", list);
      },
      error: (_) => {},
    });
  }

  /** Reaponta o control para o país de mesmo id na nova lista, mantendo a seleção após trocar o idioma. */
  private remapSelectedCountry(controlName: string, list: Country[]): void {
    const current = this.form?.get(controlName)?.value;
    if (!current?.id) return;
    const match = list.find((c) => c.id === current.id);
    if (match) this.form.get(controlName)?.setValue(match, { emitEvent: false });
  }

  createForm(account: Account) {
    // Control "language" deve armazenar objeto Language para manter consistência com login.component
    this.form = this.formBuilder.group({
      id: [account.id],
      country: [account.country, CustomValidator.getRequired()],
      name: [account.name, CustomValidator.getRequired()],
      docNumber: [account.docNumber],
      birthDate: [account.birthDate],
      phone: [account.phone, CustomValidator.getRequired()],
      phoneCountry: [account.phoneCountry, CustomValidator.getRequired()],
      email: [account.email, CustomValidator.getEmail()],
      password: [account.password, CustomValidator.getPassword()],
      passwordConfirm: [account.passwordConfirm, CustomValidator.getPassword()],
      language: [sessionStorage.getItem("language") ?? 'en-us'],
      checkCookies: [account.checkCookies, CustomValidator.getCheckbox()],
      checkNewsletter: [account.checkNewsletter],
      inactive: [account.inactive],
      inactiveReason: [account.inactiveReason],
    });
  }

  updateMask() {
    const selectedCountry = this.form.get("phoneCountry")?.value;
    const country = this.countries.find(
      (c) => c.code === selectedCountry?.code
    );

    if (country) {
      this.currentMask = country.mask;

      const phoneControl = this.form.get("phone");

      if (phoneControl) {
        const currentPhoneValue = phoneControl.value || "";
        const isValidForNewMask = new RegExp(
          this.currentMaskToRegex(country.mask)
        ).test(currentPhoneValue);

        this.f.phoneCountry.updateValueAndValidity();
      }
    }
  }

  // Converte a máscara para uma regex
  currentMaskToRegex(mask: string): string {
    return mask
      .replace(/9/g, "\\d")
      .replace(/\(/g, "\\(")
      .replace(/\)/g, "\\)")
      .replace(/\s/g, "\\s");
  }

  backLogin() {
    if (!this.deepEquals(this.form.value, this.accountInitiate)) {
      this.backBtnLoading = true;
      // Usa take(1) para evitar múltiplas emissões quando o idioma mudar depois
      this.translocoService.selectTranslate("noSaved").pipe(take(1)).subscribe((value) => {
        this.showMessage('error', value);
      });
      setTimeout(() => {
        this.router.navigate([this.loginUrl]);
        this.messageService.clear();
      }, 1000); //1s
       
    } else {
      this.router.navigate([this.loginUrl]);
    }
  }

deepEquals(form: Account, initiate: Account): boolean {
    if (!form || !initiate) return true; 

    // País
    if (!form.country || !initiate.country) {
    } else if (form.country.id !== initiate.country.id) {
      return false;
    }

    const docEmptyOrEqual = (
      (form.docNumber === null || form.docNumber === '') &&
      (initiate.docNumber === null || initiate.docNumber === '')
    ) || form.docNumber === initiate.docNumber;
    if (!docEmptyOrEqual) return false;
    if (form.name !== initiate.name) return false;
    const birthEqual = (!form.birthDate && !initiate.birthDate) ||
      (form.birthDate && initiate.birthDate && form.birthDate.getTime() === initiate.birthDate.getTime());
    if (!birthEqual) return false;
    if (this.removeMask(form.phone) !== this.removeMask(initiate.phone)) return false;
    if (form.email !== initiate.email) return false;
    if (form.password !== initiate.password) return false;
    if (form.passwordConfirm !== initiate.passwordConfirm) return false;
    if (form.checkCookies !== initiate.checkCookies) return false;
    if (form.checkNewsletter !== initiate.checkNewsletter) return false;

    return true;
  }

  async onSubmit() {
    this.checkInputs();
    if(!this.equalsPassword() ){
       this.translocoService
       .selectTranslate("user.forgotPassword.invalidPassword")
              .subscribe(
                (value) =>
                  this.showMessage('error', value)
              );
              
    }
    else if (this.form.valid) {
      // Normaliza email pra lowercase no envio (defensivo, caso blur não tenha disparado)
      const currentEmail = (this.f.email.value as string) ?? '';
      if (currentEmail && currentEmail !== currentEmail.toLowerCase()) {
        this.f.email.setValue(currentEmail.toLowerCase(), { emitEvent: false });
      }
      this.submitBtnLoading = true;
      await this.authService
        .signUp(this.form.value, sessionStorage.getItem("language"))
        .then(() => {
          this.submitBtnLoading = false;
          sessionStorage.setItem("name-activate-account", this.f.name.value);
          sessionStorage.setItem("email-activate-account", this.f.email.value);
          sessionStorage.setItem("pass", this.f.password.value);
          this.router.navigate([this.activateAccountUrl], {
            state: {
              name: this.f.name.value,
              email: this.f.email.value,
            },
          });
        })
        .catch((error) => {
          if (CognitoException.INVALID_PASSWORD === error.name) {
            this.translocoService
              .selectTranslate("user.forgotPassword.invalidPassword")
              .subscribe(
                (value) =>
                  this.showMessage('error', value)
              );
          }
          if (CognitoException.USERNAME_EXISTS === error.name) {
            this.translocoService
              .selectTranslate("user.createAccount.emailExist")
              .subscribe(
                (value) =>
                  this.showMessage('error', value)
              );
          } else if (CognitoException.LAMBDA_VALIDATION === error.name) {
            if (error.message && error.message.includes("REC-001")) {
              this.translocoService
                .selectTranslate("inputRequired")
                .subscribe(
                  (value) =>
                    this.showMessage('error', value)
                );
            } else if (error.message && error.message.includes("REC-002")) {
              this.translocoService
                .selectTranslate("user.createAccount.emailDocExist")
                .subscribe(
                  (value) =>
                    this.showMessage('error', value)
                );
            } else if (error.message && error.message.includes("REC-999")) {
              this.translocoService
                .selectTranslate("user.createAccount.undefinedError")
                .subscribe(
                  (value) =>
                    this.showMessage('error', value)
                );
            }
          } else {
            this.translocoService
              .selectTranslate("errorConection")
              .subscribe(
                (value) =>
                  this.showMessage('error', value)
              );
          }
        });

      this.submitBtnLoading = false;
    }
    else {
      this.translocoService
        .selectTranslate("inputRequired")
        .subscribe(
          (value) => this.showMessage('error', value)
        );
    }
  }

  adaptForm() {
    if (this.countryOptions.length > 0 && this.countries.length > 0) {
      if (this.selectGeoCountry === null) {
        this.selectGeoCountry = this.countryOptions[0];
      }
      this.f.country.setValue(this.selectGeoCountry);
      this.f.phoneCountry.setValue(this.selectGeoCountry);
      this.updateMask();

      // Snapshot completo do estado inicial após geolocalização/mask
      this.accountInitiate = Object.assign(new Account(), this.form.value);
    }
    // this.getMaskDocNumber();
    this.setPlaceHolderNameCpf();
    this.setTitle();
    this.setDateInterval();
  }

  checkInputs() {
    this.messages = [];
    this.messagesDocNumber = [];
    this.messagesEmail = [];
    this.messagesPassword = [];
    this.messagesCookies = [];
    this.messagesName = [];
    if (this.f.country.invalid) this.f.country.markAsDirty();
    if (!this.checkName()) this.f.name.setErrors({ nomatch: true });
    if (this.f.name.invalid) this.f.name.markAsDirty();
    //TODO nao validar data se for cnpj
    if (this.f.birthDate.invalid) this.f.birthDate.markAsDirty();
    //TODO ??? remover mascara do numero de telefone?
    if (this.f.phone.invalid) this.f.phone.markAsDirty();
    if (this.f.email.invalid) this.invalidateEmail();
    if (this.f.password.invalid) this.f.password.markAsDirty();
    if (this.f.passwordConfirm.invalid) this.f.passwordConfirm.markAsDirty();
    if (this.f.checkCookies.invalid) {
      this.f.checkCookies.markAsDirty();
      this.translocoService
        .selectTranslate("user.createAccount.cookiesTrue")
        .subscribe(
          (value) =>
            (this.messagesCookies = [{ severity: "error", summary: value }])
        );
    }
    //if(this.f.docNumber.invalid) this.f.docNumber.markAsDirty();
  }

  checkName(): boolean {
    let name = this.f.name.value;
    if (name === null) return false;

    name = name.trim();

    if (!/^[a-zA-ZÀ-ÿ\s'\-]+$/.test(name)) {
      this.translocoService
        .selectTranslate('user.createAccount.nameInvalidChars')
        .pipe(take(1))
        .subscribe(value => this.messagesName = [{ severity: 'error', summary: value }]);
      return false;
    }

    if (name.length < 3) {
      this.translocoService
        .selectTranslate('user.createAccount.nameMinLength')
        .pipe(take(1))
        .subscribe(value => this.messagesName = [{ severity: 'error', summary: value }]);
      return false;
    }

    if (name.length > 100) {
      this.translocoService
        .selectTranslate('user.createAccount.nameMaxLength')
        .pipe(take(1))
        .subscribe(value => this.messagesName = [{ severity: 'error', summary: value }]);
      return false;
    }

    const parts = name.split(/\s+/).filter((p: string) => p.length > 0);
    const valid = parts.length > 1;
    if (!valid) {
      this.translocoService
        .selectTranslate('user.createAccount.fullNameRequired')
        .pipe(take(1))
        .subscribe(value => this.messagesName = [{ severity: 'error', summary: value }]);
    }
    return valid;
  }

  checkEmail() {
    this.removeMessageEmail();
    const current = (this.f.email.value as string) ?? '';
    const lower = current.toLowerCase();
    if (current !== lower) {
      this.f.email.setValue(lower, { emitEvent: false });
    }
    if (this.f.email.invalid) {
      this.invalidateEmail();
    }
  }

  equalsPassword(): boolean {
    const same = this.f.password.value === this.f.passwordConfirm.value;
    const bothFilled = !!this.f.password.value && !!this.f.passwordConfirm.value;
    this.passwordsMatch = same && bothFilled;

    if (!same && bothFilled) {
      this.translocoService
        .selectTranslate("user.createAccount.passwordEquals")
        .subscribe(
          (value) =>
            (this.messagesPassword = [{ severity: "error", summary: value }])
        );
      return false;
    } else if (this.f.password.invalid || this.f.passwordConfirm.invalid) {
      this.messagesPassword = [];
      return false;
    } else if (same) {
      this.messagesPassword = [];
    }
    return true;
  }

  setTitle() {
    this.translocoService
      .selectTranslate("title.create-account")
      .subscribe((value) => this.titleService.setTitle(value));
  }

  getMaskDocNumber() {
    this.applyDocMaskAndValidate(this.f.docNumber.value);
  }

  private applyDocMaskAndValidate(rawValue: string | null): void {
    if (!this.isBrasil) return;
    const raw = (rawValue ?? '').replace(/\D/g, '');

    if (raw.length === 11) {
      const masked = this.addMaskCPF(raw);
      this.f.docNumber.setValue(masked, { emitEvent: false });
      if (this.validCPF(masked)) {
        this.docType = DocType.CPF;
        this.removeMessageCPFCNPJ();
        this.f.docNumber.setErrors(null);
        this.setPlaceHolderNameCpf();
        this.showBirthDate = true;
      } else {
        this.invalidateCPF();
      }
    } else if (raw.length === 14) {
      const masked = this.addMaskCNPJ(raw);
      this.f.docNumber.setValue(masked, { emitEvent: false });
      if (this.validCNPJ(masked)) {
        this.docType = DocType.CNPJ;
        this.removeMessageCPFCNPJ();
        this.f.docNumber.setErrors(null);
        this.setPlaceHolderNameCnpj();
        this.showBirthDate = false;
      } else {
        this.invalidateCNPJ();
      }
    } else {
      this.removeMessageCPFCNPJ();
      if (raw.length === 0) {
        this.f.docNumber.setErrors(null);
      } else {
        this.f.docNumber.setErrors({ incomplete: true });
      }
    }
  }

  setPlaceHolderNameCpf() {
    this.translocoService
      .selectTranslate("user.createAccount.fullName")
      .subscribe((value) => (this.placeHolderName = value + "*"));
  }
  setPlaceHolderNameCnpj() {
    this.translocoService
      .selectTranslate("user.createAccount.companyName")
      .subscribe((value) => (this.placeHolderName = value + "*"));
  }

  private removeMessageCPFCNPJ() {
    this.messagesDocNumber = [];
  }

  private removeMessageEmail() {
    this.messagesEmail = [];
  }

  private invalidateCPF() {
    this.f.docNumber.markAsDirty();
    this.f.docNumber.setErrors({ nomatch: true });
    this.translocoService
      .selectTranslate("user.createAccount.cpfValid")
      .subscribe(
        (value) =>
          (this.messagesDocNumber = [{ severity: "error", summary: value }])
      );
  }

  private invalidateCNPJ() {
    this.f.docNumber.markAsDirty();
    this.f.docNumber.setErrors({ nomatch: true });
    this.translocoService
      .selectTranslate("user.createAccount.cnpjValid")
      .subscribe(
        (value) =>
          (this.messagesDocNumber = [{ severity: "error", summary: value }])
      );
  }

  private invalidateEmail() {
    this.f.email.markAsDirty();
    this.translocoService
      .selectTranslate("user.createAccount.emailValid")
      .subscribe(
        (value) =>
          (this.messagesEmail = [{ severity: "error", summary: value }])
      );
  }

  private validCPF(value: string): boolean {
    return cpf.isValid(this.removeMask(value));
  }

  private validCNPJ(value: string): boolean {
    return cnpj.isValid(this.removeMask(value));
  }

  private addMaskCPF(str: string): string {
    // '999.999.999-99'
    if (str === null) return "";
    str = str.replace(/\D/g, "");
    str = str.replace(/(\d{3})(\d)/, "$1.$2");
    str = str.replace(/(\d{3})(\d)/, "$1.$2");
    str = str.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return str;
  }

  private addMaskCNPJ(str: string): string {
    // '99.999.999/9999-99'
    if (str === null) return "";
    str = str.replace(/\D/g, "");
    str = str.replace(/^(\d{2})(\d)/, "$1.$2");
    str = str.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    str = str.replace(/\.(\d{3})(\d)/, ".$1/$2");
    str = str.replace(/(\d{4})(\d)/, "$1-$2");
    return str;
  }

  private removeMask(str: string): string {
    if (str === null) return "";
    str = str.replaceAll(".", "");
    str = str.replaceAll("-", "");
    str = str.replaceAll("/", "");
    return str;
  }

  setIsBrasil(event: any): void {
    const selectedCountry = event.value;
    if (
      selectedCountry &&
      (selectedCountry.name === "Brasil" || selectedCountry.name === "Brazil")
    ) {
      this.isBrasil = true;
      this.f.docNumber.setValidators(CustomValidator.getRequired());
    } else {
      this.isBrasil = false;
      this.f.docNumber.clearValidators();
    }
    this.f.docNumber.updateValueAndValidity();
  }

  setDateInterval() {
    let today = new Date();
    this.maxDate = new Date();
    this.maxDate.setDate(today.getDate() - 1);
  }

  // setDateInterval() {
  //   let today = new Date();
  //   let year = today.getFullYear();
  //   let prevYear = year - 130;
  //   let nextYear =year - 14;
  //   this.minDate = new Date();
  //   this.minDate.setFullYear(prevYear);
  //   this.maxDate = new Date();
  //   this.maxDate.setFullYear(nextYear);
  // }

  changeCookies() {
    if (this.f.checkCookies.value) {
      this.messagesCookies = [];
    }
  }

  // fixLanguage(event: any) {
  //   this.language = event.option;
  //   if (this.lastLanguage !== this.language) {
  //     this.languageOptions
  //       .filter((opt) => opt.name === this.language.name)
  //       .map((cty) => (cty.disabled = true));
  //     this.languageOptions
  //       .filter((opt) => opt.name !== this.language.name)
  //       .map((cty) => (cty.disabled = false));

  //     this.lastLanguage = this.language;
  //     this.changeLanguage(this.language.name);
  //     sessionStorage.setItem('language', this.language.name);
  //     this.languageCode = this.language.name;

  //   }
  // }
  fixLanguage(event?: any) {
    this.messageService.clear();
    let selected = event && event.value ? event.value : this.f.language.value;
    // Se vier string (caso template ainda esteja enviando code), converte para objeto
    if (typeof selected === 'string') {
      selected = this.getLanguage(selected);
      this.form.get('language')?.setValue(selected, { emitEvent: false });
    }
    this.language = selected as Language;
    if (this.lastLanguage.name !== this.language.name) {
      this.userInteractedLanguage = true;
      this.languageOptions.forEach(opt => opt.disabled = (opt.name === this.language.name));
      this.lastLanguage = this.language;
      this.languageCode = this.language.name;
      this.changeLanguage(this.language.name);
      sessionStorage.setItem('language', this.language.name);
      // Recarrega os nomes dos países no novo idioma (a lista vem do backend via ?Language=),
      // preservando o país já selecionado. Sem isso a lista fica presa ao idioma do 1º carregamento.
      this.reloadCountriesForLanguage();
      // Atualiza PDFs conforme idioma selecionado
      this.privacypolicypdf =
        this.language.name === 'pt-br'
          ? 'assets/docs/politicas-de-privacidade-do-ftcloud-pt-v01.pdf'
          : 'assets/docs/politicas-de-privacidade-do-ftcloud-en-v01.pdf';
      this.termsofusepdf =
        this.language.name === 'pt-br'
          ? 'assets/docs/termos-de-uso-do-ftcloud-pt-v01.pdf'
          : 'assets/docs/termos-de-uso-do-ftcloud-en-v01.pdf';
    }
  }

  getLanguage(lan: string | null): Language {
    for (let i = 0; i < this.languageOptions.length; i++) {
      if (this.languageOptions[i].name === lan) {
        return this.languageOptions[i];
      }
    }
    return this.DEFAULT_LANGUAGE; // EN_US fallback
  }

  private normalizeLanguage(lan: string | null): string {
    const allowed = [LanguageEnum.PT_BR, LanguageEnum.EN_US, LanguageEnum.ES_ES];
    if (!lan || !allowed.includes(lan as LanguageEnum)) {
      return LanguageEnum.EN_US;
    }
    return lan as string;
  }

  public changeLanguage(languageCode: string | null): void {
    if (languageCode !== null)
      this.translocoService.setActiveLang(languageCode);
  }

  getLocation() {
    this.geolocationService.getCountry().subscribe({
      next: (data: any) => {
        // Só altera idioma via geolocalização se ainda não houve seleção manual e se não veio com idioma válido anterior
        const geoSuggest = data.country_code === 'BR' ? this.languageOptions[0] : this.languageOptions[1];
        if (!this.userInteractedLanguage && !this.initialLanguageResolved) {
          this.language = geoSuggest;
          sessionStorage.setItem('language', this.language.name);
          this.changeLanguage(this.language.name);
        } else if (!this.userInteractedLanguage && this.initialLanguageResolved && (sessionStorage.getItem('language') === null)) {
          // fallback raro se storage perder valor
          this.language = geoSuggest;
          sessionStorage.setItem('language', this.language.name);
          this.changeLanguage(this.language.name);
        }
        if (data.country_code === 'BR') {
          this.isBrasil = true;
          this.f.docNumber.setValidators(CustomValidator.getRequired());
          this.f.docNumber.updateValueAndValidity();
        }
        this.selectGeoCountry = this.countryOptions.find(
          (c) => c.code === data.country_code
        );
        if (this.selectGeoCountry !== null) {
          this.form.get("country")?.setValue(this.selectGeoCountry);
          this.form.get("phoneCountry")?.setValue(this.selectGeoCountry);
          this.adaptForm();
        } else {
          this.adaptForm();
        }
        this.refreshLanguageOptions();
      },
      error: (_) => {
        // Não sobrescrever linguagem já definida
        this.refreshLanguageOptions();
        this.adaptForm();
      }
    });
  }

  refreshLanguageOptions() {
    this.languageOptions.forEach(opt => {
      opt.disabled = (opt.name === this.language.name);
    });
  }

  get f() {
    return this.form.controls;
  }

  private showMessage(
  severity: 'success' | 'error' | 'info' | 'warn',
  summary: string
): void {
  this.messageService.clear();
  this.messageService.add({
    key: 'toastMessages',
    severity,
    summary
  });
}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
